import { getStore } from "store";
import { addSnackbarMessage } from "store/slices/snackbar.store";
export const updateVisitErrorResponse = (message: string) => {
  const response = JSON.parse(message);
  const store = getStore();
  switch (response.ErrorKey) {
    case "file-upload-fail":
      return store.dispatch(addSnackbarMessage({ key: "UpdateVisit-FileUpload-fail" }));
    case "project-task-not-found-or-done":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-ProjectTaskNotFound-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "assignment-not-found":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-AssignmentNotFound-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "bad-assignment-id":
      return store.dispatch(addSnackbarMessage({ key: "UpdateVisit-BadAssignmentId-fail" }));
    case "missing-mandatory-fields":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-MandatoryFields-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "article-not-found":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-ArticleNotFound-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "technician-not-found":
      return store.dispatch(addSnackbarMessage({ key: "UpdateVisit-TechnicianNotFound-fail" }));
    case "not-assigned-technician":
      return store.dispatch(addSnackbarMessage({ key: "UpdateVisit-NotAssignedTech-fail" }));
    case "service-article-not-found":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-ServiceArticleNotFound-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "meter-too-high":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-Meters-TooHigh-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "meter-too-low":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-Meters-TooLow-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "meter-date-too-low":
      return store.dispatch(addSnackbarMessage({ key: "CompleteVisitWithParts-fail" }));
    case "meter-not-saved":
      return store.dispatch(addSnackbarMessage({ key: "UpdateVisit-Meters-NotSaved-fail" }));
    case "meter-validation-mean-units-between-visit":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-Meters-MeanUnits-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    case "meter-validation-units-per-month":
      return store.dispatch(
        addSnackbarMessage({
          key: "UpdateVisit-Meters-UnitsPerMonth-fail",
          argument: response.ErrorInfo ?? "",
        }),
      );
    default:
      return store.dispatch(addSnackbarMessage({ key: "CompleteVisitWithParts-fail" }));
  }
};
